import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const Comparison: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Comparison
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography>Comparison content will be added here.</Typography>
      </Paper>
    </Box>
  );
};

export default Comparison;
